import { ReactNode } from 'react';
import { CourseMappingFilterState } from './courseMappingFilterFields';

export interface CourseMappingPreset {
  id: string;
  title: string;
  description: ReactNode;
  filters: CourseMappingFilterState;
}

export const DEFAULT_PRESET_ID = 'all-courses';

export const COURSE_MAPPING_PRESETS: CourseMappingPreset[] = [
  {
    id: DEFAULT_PRESET_ID,
    title: 'All courses',
    description: 'The table below shows all the courses mapped in your course catalogs.',
    filters: [],
  },
  {
    id: 'verify-college-prep',
    title: 'Verify if college prep',
    description: (
      <ol className="course-mapping-page-instructions">
        <li>
          In the <strong>College Prep</strong> column, select all courses that apply (if any).
        </li>
        <li>
          Click the <strong>Save changes</strong> button.
        </li>
      </ol>
    ),
    filters: [{ key: 'isCollegePreparatory', value: 'false' }],
  },
  {
    id: 'math-or-science',
    title: 'Subject area: math or science',
    description: (
      <ol className="course-mapping-page-instructions">
        <li>
          Review the data in the <strong>Subject area</strong> column and decide if the value should be{' '}
          <strong>Mathematics</strong> or <strong>Science</strong>.
        </li>
        <li>
          Click the <strong>Save changes</strong> button.
        </li>
      </ol>
    ),
    filters: [{ key: 'subjectArea', value: ['Science', 'Mathematics'] }],
  },
];

export const findPreset = (id: string): CourseMappingPreset | undefined =>
  COURSE_MAPPING_PRESETS.find((preset) => preset.id === id);
